import React, { useState, useEffect, useRef } from 'react';
import { useParams, ScrollRestoration, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL, CURRENTPAYSLIPS_URL, TIMEATTENDANCE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'
import Spinner from './Spinner';

// Hook
import axios from 'axios';
import useAuth from '../hooks/useAuth';
import { useEmployeeListFetch } from '../hooks/useEmployeeList';
import { useCurrentPayrunListFetch } from '../hooks/useCurrentPayrunListFetch';
import { useTimeAttendanceListFetch } from '../hooks/useTimeAttendanceListFetch';
import { usePayTypesListFetch } from '../hooks/usePayTypesListFetch';
// Image
import NoImage from '../images/no-image.png';
import Grid from './Grid';


let renderCount = 0

const Clockings = () => {
  const auth = useAuth();
  const { playerid } = useParams()
  const location = useLocation();
  const navigate = useNavigate()
  const form = useForm({
    defaultValues: {
      inoutType: 'in',  // Ensures form starts with "in" but allows updates
    }
  })
  const { register, control, watch, handleSubmit, formState, reset, setValue } = form
  const from = location.state?.from || './'
  console.log(playerid)
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
  const [inoutSwitch, setInOutSwitch] = useState(false)
  const [errMessage, setErrMessage] = useState("");
  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useEmployeeListFetch(playerid);
  const [employees, setEmployees] = useState([])
  const { timeAttendancestate, timeAttendanceloading, timeAttendanceerror, timeAttendancesearchValue, timeAttendancesetLoading, timeAttendancesetSearchValue, timeAttendancesetIncludeInactive, fetchTimeAttendanceList } = useTimeAttendanceListFetch(startDate, endDate);
  const { paytypestate, paytypeloading, paytypeerror, paytypesearchValue, paytypesetSearchValue, paytypesetIncludeInactive, fetchPayTypesList } = usePayTypesListFetch();
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  const username = auth.auth.user.username
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllFARW, setSelectAllFARW] = useState(false);
  const inoutType = watch("inoutType", 'in'); // Default to "in"
  const registerDate = watch('registerDate')

  const prevInOutType = useRef(inoutType);

  useEffect(() => {
    if (prevInOutType.current !== inoutType) {
     reset((formValues)=>({
      ...formValues,
      employeeCheck:{}
     })) 
    }     
  }, [inoutType, reset]);
 

  useEffect(() => {
    setStartDate(registerDate);
    setEndDate(registerDate);
  }, [registerDate]);

  useEffect(() => {
    const now = new Date()
    const localDate = now.toISOString().slice(0, 10)
    const localTime = now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }); // 24-hour format
    setValue("clocktime", localTime);
    setValue('registerDate', localDate)


  }, [setValue]);

  useEffect(() => {
    if (!state.employees || !timeAttendancestate.timeAttendances) return;
    setLoading(true)
    const currentDate = new Date(registerDate).getTime();
    const clockedInEmployees = timeAttendancestate.timeAttendances.filter(
      (val) => new Date(val.date).getTime() === currentDate &&
        !val.clockOutTime
    );

    console.log(clockedInEmployees)

    if (inoutType === "in") {
      // Employees who haven't clocked in
      setEmployees(
        state.employees.filter(emp => !clockedInEmployees.some(val => val.employee._id === emp._id))
          .sort((a, b) => a.surname.localeCompare(b.surname))
      );
    } else {
      // Employees who have clocked in and need to clock out
      setEmployees(clockedInEmployees.map(clocking => clocking));
    }

    

    setLoading(false)
  }, [state.employees, timeAttendancestate.timeAttendances, inoutType, registerDate]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    // Update all checkboxes in the form
    employees.forEach((employee) => {
      setValue(`employeeCheck.${employee._id}`, newSelectAll);
    });
  };
  const handleSelectAllFARW = () => {
    const newSelectAllFARW = !selectAllFARW;
    setSelectAllFARW(newSelectAllFARW);

    // Update all checkboxes in the form
    employees.forEach((employee) => {
      if(employee.dept==="FARW"){

        setValue(`employeeCheck.${employee._id}`, newSelectAllFARW);
      }
    });
  };

  const onSubmit = async (data) => {
    console.log("Submit is clicked");
    console.log(data);


    const selectedEmployees = Object.entries(data.employeeCheck || {})
      .filter(([_, isChecked]) => isChecked)
      .map(([employeeId]) => employeeId);

    // Get the current date from form input
    const currentDate = new Date(data.registerDate);
    const [hours, minutes] = data.clocktime.split(":");
    const clockInDate = new Date(currentDate.setHours(hours, minutes));

    let submissionData = [];



    if (inoutType === "in") {
      // Clocking IN
      submissionData = selectedEmployees.map((employee) => ({
        employee: employee,
        paytype: data.paytype,
        date: data.registerDate,
        clockInTime: clockInDate,
      }));

      console.log(submissionData)

      try {
        const response = await axios.post(
          `${TIMEATTENDANCE_URL}`,
          JSON.stringify({ data: submissionData }),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + accessToken,
            },
          }
        );

        console.log(response);
        setTrigger(true);
        timeAttendancesetIncludeInactive(true);

        reset({ employeeCheck: {} });

      } catch (error) {
        handleApiError(error);
      }
    } else {
      // Clocking OUT
      console.log(selectedEmployees)
      submissionData = selectedEmployees.map((employee) => ({
        recordId: employee,
        date: data.registerDate,
        clockOutTime: clockInDate,
      }));

      try {
        const responses = await Promise.all(
          submissionData.map(async (submission) => {
            return axios.patch(
              `${TIMEATTENDANCE_URL}/${submission.recordId}`,
              JSON.stringify({ data: submission }),
              {
                headers: {
                  "Content-Type": "application/json",
                  authorization: "Bearer " + accessToken,
                },
              }
            );
          })
        );

        console.log(responses);
        setTrigger(true);
        timeAttendancesetIncludeInactive(true);
        reset({ employeeCheck: {} });
        console.log(employees)

      } catch (error) {
        handleApiError(error);
      }

    }

    console.log(submissionData);
  };

  // Helper function to handle API errors
  const handleApiError = (error) => {
    if (!error.response) {
      setErrMessage("No server response");
    } else if (error.response?.status === 400) {
      setErrMessage("Missing data");
    } else if (error.status === 500) {
      console.log(error.message);
      setErrMessage(error.message + " " + error.response?.data?.msg?.message);
    } else {
      setErrMessage("Request failed");
    }
    console.log(error);
  };




  renderCount++
  return (
    <>

      <Header username={username} role={access} destination={from}></Header>


      <div>Time Attendance List</div>

      {(timeAttendanceloading) && <Spinner></Spinner>}

      <form onSubmit={handleSubmit(onSubmit)}>

        <div className='formVariables'>
          <div className='Lineitem'>
            <label>Date to Log</label>
            <input
              className="inputsize" type={"date"}
              max={new Date().toISOString().split("T")[0]}
              {...register(`registerDate`, { required: 'Date is required' })} />

          </div>
          <div className='Lineitem'>
            <label>Clocking Type</label>
            <select
                            className="inputsize"

                            {...register(`paytype`, { required: 'Paytype is required' })}
                          >
                            <option value=''>select</option> {/* Default option */}

                            {paytypestate?.paytypes?.map((paytype) => (
                              <option key={paytype._id} value={paytype._id}>
                                {paytype.description}
                              </option>
                            ))}
                          </select>

          </div>

          <div className='Lineitem'>

            <label>Clocking In or Out</label>
            <div>
              <label>In</label>
              <input type='radio' name='in/out' value={'in'}{...register("inoutType")}></input>
              <label>Out</label>
              <input type='radio' name='in/out' value={'out'} {...register("inoutType")}></input>
            </div>
          </div>
          <div className='Lineitem'>
            <label>Clock time</label>
            <input
              className="inputsize" type={"time"}
              {...register(`clocktime`, { required: 'Time is required' })} />

          </div>
        </div>

        {new Date(registerDate) > new Date() ?

          <div>You cannot process in advance. The selected date is in the future. Please select another date.</div>
          :


          (
            <>
              <Knoppie
                text={"Submit"}
                callback={handleSubmit(onSubmit)}
              />

              {employees.length === 0 && inoutType === 'out' &&
                <div>There are no employees Clocked In.</div>
              }

              {employees.length === 0 && inoutType === 'in' &&
                <div>All the employees are Clocked In.</div>
              }
              {employees.length > 0 &&
                <>
                <ButtonGrid>
                  <div className='checkLineitem'>
                    <div></div>
                    <Knoppie
                      clickable={true}
                      dropdown={true}
                      text={selectAll ? "Deselect All" : "Select All"}
                      callback={handleSelectAll}
                    />
                  </div>
                  <div className='checkLineitem'>
                    <div></div>
                    <Knoppie
                      clickable={true}
                      dropdown={true}
                      text={selectAllFARW ? "Deselect All FARW" : "Select All FARW"}
                      callback={handleSelectAllFARW}
                    />
                  </div>
                  </ButtonGrid>
                </>
              }

              {inoutType === 'in' ?
                (employees?.map((employee) => (
                  <>
                    <div className='checkLineitem' key={employee._id}>
                      <div className='info'>
                      <div>{employee.dept}</div>
                      <div>{employee.givname + " " + employee.surname}</div>
                      </div>
                      <input
                        id={employee._id}
                        type="checkbox"
                        {...register(`employeeCheck.${employee._id}`)}
                      />
                    </div>
                  </>
                ))) :
                (employees?.map((attendance) => (
                  <>
                    <div className='checkLineitem' key={attendance._id}>
                      <div>{attendance.employee.givname + " " + attendance.employee.surname}</div>
                      <input
                        id={attendance._id}
                        type="checkbox"
                        {...register(`employeeCheck.${attendance._id}`)}
                      />
                    </div>
                  </>
                )))

              }
            </>

          )


        }





      </form>


    </>
  );
};

export default Clockings;

